import type { ReactNode } from 'react'
import { PageHeading } from './ui'

/**
 * The top of a screen (DESIGN.md, "Staff app direction"): its title, the
 * page's h1, focused on arrival; a status beside it; a line saying what the
 * screen is for; and a quieter line, such as when it was last checked. On a
 * pane of its own: no word sits on the depth behind the app.
 *
 * A screen inside another (a booking in its list) puts the way back above the
 * title; the screen's own actions stand at the end of the title's row, and
 * what belongs with them, such as why one is not offered yet, goes below.
 */
export function PageHeader({
  title,
  status,
  intro,
  meta,
  back,
  actions,
  children,
}: {
  title: ReactNode
  status?: ReactNode
  intro?: ReactNode
  meta?: ReactNode
  back?: ReactNode
  actions?: ReactNode
  children?: ReactNode
}) {
  return (
    <div className="glass-pane flex flex-col gap-2 rounded-card p-4 sm:p-6">
      {back}
      <div className="flex flex-wrap items-center gap-3">
        <PageHeading className="text-3xl">{title}</PageHeading>
        {status}
        {actions ? (
          <div className="ms-auto flex flex-wrap items-center gap-3">{actions}</div>
        ) : null}
      </div>
      {intro ? <p className="max-w-prose">{intro}</p> : null}
      {meta ? <p className="text-sm text-text-muted">{meta}</p> : null}
      {children}
    </div>
  )
}
